module.exports = __webpack_public_path__ + "static/img/step3.fb0b1bb8.png";